import { render } from "./JurnalDay.vue?vue&type=template&id=660e20d2"
import script from "./JurnalDay.vue?vue&type=script&lang=js"
export * from "./JurnalDay.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__